export const LIST_SELECTED_STUFFS = 'LIST_SELECTED_STUFFS';
